import 'bootstrap';

import { mount } from 'svelte';
import App from '../svelte/components/Bout.svelte';

const appPlaceholder = document.querySelector('#bout-page');

if (appPlaceholder) {
	mount(App, { target: appPlaceholder });
}
